import React, { useCallback, useEffect, useState } from "react";
import {
  ContainerList,
  ContainerSubMenu,
  ContainerVista,
  ItemBox,
  Menu,
  SubMenu,
} from "./Styled.components";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { buildUrl, buildMenu } from "../../../utils";

const ChildrenBlur = ({ children, onBlur, ...props }: any) => {
  const handleBlur = useCallback(
    (e: any) => {
      const currentTarget = e.currentTarget;
      if (!currentTarget.contains(document.activeElement)) {
        onBlur();
      }
    },
    [onBlur]
  );

  return (
    <ContainerList {...props} onBlur={handleBlur}>
      {children}
    </ContainerList>
  );
};

export const ListMenu = () => {
  const { modules, modo } = useSelector((state: any) => state.user);
  const { themeMenu } = useSelector((state: any) => state.theme);
  const [menu, setMenu] = useState<any>([]);
  const [expand, setExpand] = useState<any>({});
  const [expandSub, setExpandSub] = useState<any>({});
  const history = useNavigate();

  useEffect(() => {
    if (!modules) return;

    const expand: Record<string, boolean> = {};
    const expandSub: Record<string, boolean> = {};
    const menus = buildMenu(modules, expand, expandSub);

    setExpand(expand);
    setExpandSub(expandSub);
    setMenu(menus);
  }, [modules]);


  const handleClick =
    (name: any = null) =>
      (event: any) => {
        let keys: any = {};
        Object.keys(expand).map((k: any) => {
          keys[k] = false;
        });
        if (name !== null) {
          keys = { ...keys, [name]: !expand[name] };
        } else {
          handleClickSub()(event);
        }
        setExpand(keys);
      };
  const handleClickSub =
    (name: any = null) =>
      (event: any) => {
        console.log(name, event);
        let keys: any = {};
        Object.keys(expandSub).map((k: any) => {
          keys[k] = false;
        });
        if (name !== null) {
          keys = { ...keys, [name]: !expandSub[name] };
        }
        setExpandSub(keys);
      };

  return (
    <ChildrenBlur onBlur={handleClick}>
      {menu.map((data: any, index: number) => (
        <Menu
          modo={modo}
          tabIndex={1}
          className="pruebaprueba"
          key={index}
          expand={expand[data.key]}
          textMenu={themeMenu?.textColor || ""}
        >
          <span className={"itemMenu"} onClick={() => history(data.url)}>
            {data.text}
          </span>
          {data.children.length > 0 ? (
            <span onClick={handleClick(data.key)}>
              {" "}
              {expand[data.key] ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </span>
          ) : null}
          <ContainerSubMenu expand={expand[data.key]}>
            <SubMenu>
              {data.children.map((hijos: any, indexH: number) => (
                <ItemBox
                  hijos={hijos.children.length > 0}
                  expand={expandSub[hijos.key]}
                  key={indexH}
                >
                  <div className="item">
                    {hijos.url.split("/")[2] ? (
                      <span
                        className="btnOnClick"
                        onClick={() => history(hijos.url)}
                      >
                        {hijos.text}
                      </span>
                    ) : (
                      <p>{hijos.text}</p>
                    )}
                    {hijos.children.length > 0 ? (
                      <span
                        className="btnArrow"
                        onClick={handleClickSub(hijos.key)}
                      >
                        {" "}
                        {expandSub[hijos.key] ? (
                          <KeyboardArrowLeftIcon className="icon" />
                        ) : (
                          <KeyboardArrowRightIcon className="icon" />
                        )}{" "}
                      </span>
                    ) : null}
                  </div>
                  <ContainerVista expand={expandSub[hijos.key]}>
                    <ItemBox>
                      {hijos.children.map((vistas: any, indexV: number) => (
                        <div key={indexV} className="item">
                          <span
                            className="btnOnClick"
                            onClick={() => history(vistas.url)}
                          >
                            {vistas.text}
                          </span>
                          <span
                            className="btnArrow"
                            onClick={() =>
                              window.open(
                                vistas.url,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            {" "}
                            <OpenInNewIcon
                              sx={{ fontSize: 20 }}
                              className="icon"
                            />{" "}
                          </span>
                        </div>
                      ))}
                    </ItemBox>
                  </ContainerVista>
                </ItemBox>
              ))}
            </SubMenu>
          </ContainerSubMenu>
        </Menu>
      ))}
    </ChildrenBlur>
  );
};
